import React from "react";
import { GitPullRequestLine } from "@ui/IconV2/react";
import { colors } from "@ui/Theme";
import t from "../../../../../../../../../i18n";
import type { BlockDiagramModelT } from "../../../../../../schema/block/diagram";

export const DiagramTemplate = {
  icon: () => <GitPullRequestLine size="l" color={colors.carbon800} />,
  title: t("project.dashboard.block.template.diagram.sub_subtitle"),
  description: null,
  block: {
    kind: "DIAGRAM" as const,
    data: {
      title: "",
      period: "ALL" as const,
      resources: [],
    },
    config: {
      url: "",
      live: true,
      show_all: true,
      show_role: false,
      aggregate: false,
      layers: [] as BlockDiagramModelT["config"]["layers"],
    },
  },
};
